const initialState = {
  imBusy: false,
  items: [],
  error: false,
  coupon: "",
  unit: "PLN",
  shipping: {},
  shippingRules: {},
  shippings: [],
  orderInApi: {},
  sum: {
    val: 0,
    qty: 0,
  },

  payment: {
    msg: "Proszę czekać...",
    phase: "idle",
  },
}

export default initialState
